import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { readConfig } from './config';

export const config = readConfig(import.meta.env);

export const supabase: SupabaseClient | null = config
  ? createClient(config.url, config.publishableKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
